import React, {useState, useEffect, useContext} from 'react';

import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import Start from './prawnik/start/Start';
import NewsCenter from './prawnik/powiadomienia/NewsCenter';
import ZadajBezplatnePytanie from './zadaj_bezplatne_pytanie/ZadajBezplatnePytanie';
import Potwierdzenie from './bezplatna_konsultacja_telefoniczna/potwierdzenie/Potwierdzenie';
import {Routes, Route} from 'react-router-dom';
import {LawyerContext, CategoriesContext, LoadingContext, UserContext} from '../partials/Context';
import {getCategories, getLawyer} from '../functions/api';
import { Errors, Loader } from '../partials/Partials';
import Statistics from './prawnik/statystyka_profilu/Statistics';
import Portfel from './prawnik/portfel/Portfel';
import DataEdit from './prawnik/edycja/DataEdit';
import DodajPrawnika from './dodaj-prawnika/DodajPrawnika';
import ServicesNavigation from './zadaj_bezplatne_pytanie/ServicesNavigation';
import WKZapytajPrawnika from './zadaj_bezplatne_pytanie/WKZapytajPrawnika';
import Statystyki from './wolters_kluwer/Statystyki';



function LayoutBox(props) {
    const [lawyer, setLawyer] = useState({});
    const [categories, setCategories] = useState({});
    const [errors, setErrors] = useState([]);
    const {loading} = useContext(LoadingContext);
    const user = useContext(UserContext);
    const {is_authenticated} = user || '';
    const [titles, setTitles] = useState([]);
    let lawyer_titles = [];
    let pathname = window.location.pathname.slice(1, -1).split('/');
    const {is_staff} = user || ''

    useEffect(()=> {
        if (is_authenticated) {
            getLawyer(setLawyer, setErrors);
        }
        getCategories(setCategories, setErrors);
    },[is_authenticated])

    useEffect(() => {
        fetch('/api/titles/').then(res=>res.json().then(
            data => setTitles(data)
        ))
    },[])

    if (titles) {
        titles.forEach(item => {
            lawyer_titles.push(item.name.toLowerCase().split(' ').join('-'))
        })
        lawyer_titles.push('prawnik')
    }

    let category_slug = '';
    let categories_all = [];
    if (categories.prywatne && categories.firmowe) {
        const {prywatne, firmowe} = categories || ''
        categories_all = [...prywatne, ...firmowe]
    }

    if (pathname.length === 2 && pathname[0] === 'zadaj-bezplatne-pytanie') {
        let category_pathname = pathname[1];

        categories_all.forEach(category => {
            const {slug} = category || ''
            if (category_pathname === slug) {
                category_slug = category_pathname
            }
        })
    }

    let if_wallet_url = window.location.pathname.match(/prawnik-portfel\/(prawnik-[0-9]+\/([0-9]+\/)?)?$/)

    let if_WK = window.location.pathname.match(/zapytaj-prawnika(\/kategoria\/[a-zA-Z0-9\-_]+)?\/wk\/$/);

    let if_simplified = window.location.pathname === '/statystyki/'

        return (
            <LawyerContext.Provider value={lawyer}>
                <Navbar simplified={if_simplified}/>
                <CategoriesContext.Provider value={categories}>
                <div className="layout-box">
                    <div className="container">
                        <div id="content" className="row">
                            <div className="row">
                            <Errors errors={errors} />
                                <Routes>
                                <Route path='prawnik/start/'element={<Start/>}/>
                                <Route path='prawnik/powiadomienia/'element={<NewsCenter/>}/>
                                <Route path='prawnik/statystyka-profilu/'element={<Statistics/>}/>
                                <Route path='prawnik/edycja/*' element={<DataEdit />}/>
                                <Route exact path={ `/zadaj-bezplatne-pytanie/`} element={<ZadajBezplatnePytanie/>}/>
                                <Route exact path={ `/zadaj-bezplatne-pytanie/${category_slug}`} element={<ServicesNavigation/>}/>
                                <Route exact path="dodaj-prawnika/" element={<DodajPrawnika />} />
                                <Route path={`/bezplatna-konsultacja-telefoniczna/potwierdzenie/*`} element={<Potwierdzenie/>} />
                                <Route exact path="statystyki/" element={<Statystyki/>} />
                                {if_WK ?
                                <Route path={'/zapytaj-prawnika/kategoria/*'} element={<WKZapytajPrawnika/>}/>
                                :null
                                }
                                {if_wallet_url ?
                                    is_staff ? 
                                        <Route path='prawnik-portfel/*' element={<Portfel />}/>
                                    : <Route path='prawnik-portfel/' element={<Portfel />}/>
                                : null
                                }
                                </Routes>
                            </div>
                        </div>
                    </div>
                </div>
                </CategoriesContext.Provider>
                {
                    window.location.pathname !== '/statystyki/' ?
                    <Footer/> : <Footer simplified={true}/>
                }
                <Loader classes={`${loading ? 'active' : ''}`}/>
            </LawyerContext.Provider>
        )
}

export default LayoutBox